import type React from 'react';
import { useMemo } from 'react';

import st from './AttributeInfoRow.module.sass';

interface AttributeInfoRowProps {
  title: string;
  value: React.ReactNode;
}

function AttributeInfoRow({
  title,
  value,
}: AttributeInfoRowProps): React.JSX.Element {
  const $value = useMemo(() => {
    if (typeof value === 'number') return value.toFixed(5);
    if (!value) return '-';
    return value;
  }, [value]);
  return (
    <div className={st.Root}>
      <div className={st.Label}>
        {title}
      </div>
      <div className={st.Value}>
        {$value}
      </div>
    </div>
  );
}

export { AttributeInfoRow };
